import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { putDraftStatus } from "../services/httpCalls";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Cookies from "js-cookie";
import useNotify from "../utils/useNotify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "82vh",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 2,
};
const PreviewApproveFifCB = ({ url, docId, status, closeTable }) => {
  const [open, setOpen] = React.useState(false);
  let opsUser = Cookies.get("userInfo");
  opsUser = JSON.parse(opsUser);

  const [documentStatus, setDocumentStatus] = useState({
    draft15CBStatus: "",
    statusUpdatedBy: opsUser?.id,
    userType: "OPS_MEMBER",
  });
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  const notify = useNotify();
  useEffect(() => {
    if (documentStatus.draft15CBStatus) {
      if (documentStatus.draft15CBStatus === "APPROVED") {
        handleApprove();
      } else {
        handleReject();
      }
    }
  }, [documentStatus]);
  const handleApprove = async () => {
    await putDraftStatus(docId, documentStatus).then((res) => {
      notify.success("Approved the Draft");
    });
    await handleClose();
    await closeTable();
  };
  const handleReject = async () => {
    await putDraftStatus(docId, documentStatus).then((res) => {
      notify.error("Rejected the Draft");
    });
    await handleClose();
    await closeTable();
  };
  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <RemoveRedEyeIcon
          sx={{
            color: "#1876D1",
            fontSize: "25px",
          }}
        />
      </IconButton>
      <Modal open={open} onClose={handleClose}>
        <Box>
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  marginLeft: "10px",
                  fontSize: "20px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
                component="h2"
              >
                Preview Files
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                height: "calc(90% - 50px)",
              }}
            >
              <iframe
                src={url}
                width="100%"
                height="100%"
                title="previewDocs"
              ></iframe>
            </Box>
            <Box
              sx={{
                display: "flex",
                mt: 2,
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  setDocumentStatus({
                    ...setDocumentStatus,
                    draft15CBStatus: "APPROVED",
                  });
                }}
                disabled={status === "APPROVED" || status === "REJECTED"}
              >
                Approve
              </Button>
              <Button
                variant="outlined"
                sx={{
                  ml: 2,
                }}
                color="error"
                onClick={() => {
                  setDocumentStatus({
                    ...setDocumentStatus,
                    draft15CBStatus: "REJECTED",
                  });
                }}
                disabled={status === "APPROVED" || status === "REJECTED"}
              >
                Reject
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default PreviewApproveFifCB;
